<template>
  <a
    :href="item.link"
    class="btn flex items-center justify-center"
    :class="[
      item.showAlways ? '' : 'lg:hidden',
      btnClass,
      item.roundedCorners ? 'rounded-full' : 'rounded-md',
      item.iconSide === 'right' ? 'flex-row-reverse' : '',
    ]"
    :aria-label="item.label ? null : 'Neem contact op via WhatsApp'"
    @click="sendTagManagerEvent"
  >
    <IconWhatsapp
      class="h-6 w-6"
      :class="item.iconSide === 'right' ? 'ml-2' : 'mr-2'"
      aria-hidden="true"
    />
    <span class="block">{{ item.label }}</span>
  </a>
</template>

<script setup>
import { computed } from 'vue'
import IconWhatsapp from '../icons/IconWhatsapp.vue'

const props = defineProps({
  item: {
    type: Object,
    default: () => {},
  },
})

const btnClass = computed(() => {
  return `btn-style-${props.item.style}-whatsapp`
})
const purpose = computed(() => {
  return props.item.purpose || 'chat'
})

function sendTagManagerEvent() {
  if (window.dataLayer) {
    window.dataLayer.push({
      event:
        purpose.value === 'chat'
          ? 'jrUniversalChatWhatsApp'
          : 'jrUniversalShareWhatsApp',
    })
  }
}
</script>
